export class AmendReasons {
public static RecordedIncorrectQuantity = "Recorded incorrect quantity";
public static ReturnedToStock = "Returned to stock";
public static RecordedIncorrectDrugNdc = "Recorded incorrect drug/NDC";
public static RecordedIncorrectRxNumberAndOrPatientName = "Recorded incorrect Rx Number and/or Patient Name";
public static Other = "Other";
}